import React from 'react'

import { FieldArray } from 'formik'

import LABEL from '../../../business-const/Label/Label'

import NUMMIN from '../../../business-rules/NumMinMax/NumMin'

import NUMMAX from '../../../business-rules/NumMinMax/NumMax'

import TAMMAX from '../../../business-rules/TamMax/TamMax'

import {
    DivForm,
} from '../../../business-components/Div/Div'

import {
    GridContainer,
    GridItem1,
    GridItem2xs4,
    GridItem3xs6,
    GridItem5xs10,
    GridItem6xs11,
    GridItem10,
    GridItem11,
} from '../../../business-components/Grid/Grid'

import {
    TextValidatorText,
    TextValidatorValor,
    TextValidatorNumber,
} from '../../../business-components/TextValidator/TextValidator'

import { 
    TextFieldNumberSelect,
} from '../../../business-components/TextField/TextFieldSelect'

import {
    IconButtonClearEntradaDados
} from '../../../business-components/IconButton/IconButton'

import {
    ButtonIncluirLinha
} from '../../../business-components/Button/Button'

import {
    pesquisaList
} from '../../../business-rules/List/ListService'



const FormFormMultiList = ({ values, handleChange, linhaPerguntas, indPergunta }) => {

    const listSelecao = ( id ) => {

        let listSelecaoAux = []
    
        linhaPerguntas.list?.forEach( (item, ind) => {
            
            if (
                    (
                        item.id === id ||
                        !pesquisaList(values.perguntas[indPergunta].multiList, item.id, 'idList').idList
                    )
            ) {

                listSelecaoAux.push(
                    {
                        id: item.id,
                        descricao: item.descricao,
                        ordem: item.ordem,
                    }
                )
            }
        })

        return listSelecaoAux
    }

    return (
        <FieldArray name={`perguntas[${indPergunta}].multiList`}>
            {(arrayHelpers) => (
                <DivForm>
                    <DivForm>
                        {values.perguntas[indPergunta].multiList?.map((item, ind) => {
                            return (
                                <>
                                    <GridContainer
                                        key={ind}
                                    >
                                        <GridItem6xs11>
                                            <TextFieldNumberSelect
                                                name={`perguntas[${indPergunta}].multiList[${ind}].idList`}
                                                label={""}
                                                value={item.idList || ''}
                                                onChange={handleChange}
                                                list={listSelecao(item.idList)}
                                            />
                                            {linhaPerguntas.idOutros &&
                                            item.idList === linhaPerguntas.idOutros && (
                                                <GridContainer>
                                                    <GridItem1/>

                                                    <GridItem11>
                                                        <TextValidatorText
                                                            name={`perguntas[${indPergunta}].multiList[${ind}].idListOutros`}
                                                            label={""}
                                                            value={item.idListOutros || ''}
                                                            onChange={handleChange}
                                                            tamMax={linhaPerguntas.tamMaxOutros}
                                                        />
                                                    </GridItem11>
                                                </GridContainer>
                                            )}
                                        </GridItem6xs11>
                                        <GridItem1
                                            className={'mt-2'}
                                        >
                                            <IconButtonClearEntradaDados
                                                onClick={() =>
                                                    arrayHelpers.remove(ind)
                                                }
                                            />
                                        </GridItem1>
                                    </GridContainer>

                                    {linhaPerguntas.multiListInformarMotivoValorPrazoComentarios && (
                                        <>
                                            <GridContainer>
                                                <GridItem1/>

                                                <GridItem5xs10>
                                                    <TextValidatorText
                                                        name={`perguntas[${indPergunta}].multiList[${ind}].motivo`}
                                                        label={LABEL.motivo}
                                                        value={item.motivo || ''}
                                                        onChange={handleChange}
                                                        tamMax={TAMMAX.motivo}
                                                    />
                                                </GridItem5xs10>
                                            </GridContainer>

                                            <GridContainer>
                                                <GridItem1/>

                                                <GridItem3xs6>
                                                    <TextValidatorValor
                                                        name={`perguntas[${indPergunta}].multiList[${ind}].valor`}
                                                        label={LABEL.valor}
                                                        value={item.valor || ''}
                                                        onChange={handleChange}
                                                    />
                                                </GridItem3xs6>

                                                <GridItem2xs4>
                                                    <TextValidatorNumber
                                                        name={`perguntas[${indPergunta}].multiList[${ind}].prazoAnos`}
                                                        label={LABEL.prazoAnos}
                                                        value={item.prazoAnos === 0 ? 0 : item.prazoAnos || ''}
                                                        onChange={handleChange}
                                                        numMin={NUMMIN.anos}
                                                        numMax={NUMMAX.anos}
                                                    />
                                                </GridItem2xs4>
                                            </GridContainer>

                                            <GridContainer>
                                                <GridItem1/>

                                                <GridItem10>
                                                    <TextValidatorText
                                                        name={`perguntas[${indPergunta}].multiList[${ind}].comentario`}
                                                        label={LABEL.comentario}
                                                        value={item.comentario || ''}
                                                        onChange={handleChange}
                                                        tamMax={TAMMAX.comentario}
                                                        notToUpperCase={true}
                                                    />
                                                </GridItem10>
                                            </GridContainer>
                                        </>
                                    )}
                                </>
                            )
                        })}
                    </DivForm>

                    <GridContainer>
                        <ButtonIncluirLinha
                            label={linhaPerguntas.labelButtonIncluirLinha} 
                            onClick={() => 
                                arrayHelpers.push({
                                })
                            }
                        />
                    </GridContainer>
                </DivForm>
            )}
        </FieldArray>
    )
}

export default FormFormMultiList